module.exports = "<div class=\"promo-content\">\r\n    <p><strong>Sorry, this information is not available to free users. Please upgrade to JustisOne Professional.</strong></p>\r\n    <p>{{> upgrade-button}}</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/open-promo-content-unavailable.html
// module id = 442
// module chunks = 1